import React from 'react';
import { Card } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';

const PartnerPerIniziare = () => {

  return (<>
    <PageHeader
    title="Per creare e compilare i questionari"
    description=""
    className="mb-3"
    >
    </PageHeader>
    
    <Card style={{marginTop:"2%", marginBottom:"2%"}}>
        <Card.Body>
          <Card.Title>
            <h5 className="text-info fw-medium mb-0" style={{marginBottom:"3%"}}>Per creare un nuovo questionario</h5>
          </Card.Title>
          <Card.Text>
            <p>Per creare un nuovo questionario il partner dovrà:</p>
            <ul>
              <li>Cliccare sulla prima voce del Menù, in alto a sinistra: <strong><em>"Questionari"</em></strong>.</li>
              <li>Appare l'elenco dei questionari già creati.</li>
              <li><strong>Cliccare sul pulsante [ Crea nuovo questionario ]</strong>.</li>
              <li>Si apre il modulo di inserimento dati "Crea nuovo questionario".</li>
              <li>È obbligatorio inserire nel modulo <strong>i primi 5 campi</strong>:
                  <ul>
                    <li><strong>Email</strong> del referente aziendale, da usare come UserName per accedere al sistema</li>
                    <li><strong>Password</strong> per il referente</li>
                    <li><strong>Nome</strong> del referente aziendale</li>
                    <li><strong>Cognome</strong> del referente</li>
                    <li><strong>Nome</strong> dell'azienda</li>
                  </ul>
              </li>
              <li>I restanti sei campi sono facoltativi.</li>
              <li><strong>Cliccare sul pulsante [ Invia ] nella parte bassa del modulo</strong>.</li>
            </ul>
            <p>La pagina ritornerà all'elenco dei questionari già creati.</p>
            <hr/>
            <p>A questo punto:</p>
            <ul>
              <li>
                <p><strong><span style={{color:'blue'}}>Il partner</span></strong> potrà accedere direttamente al questionario cliccando sul pulsante <strong>[ Accedi ]</strong> presente nell'elenco dei questionari.</p>
              </li>
              <li>
                <p><strong><span style={{color:'blue'}}>Il referente aziendale</span></strong> potrà invece accedere al questionario andando alla pagina <strong>https://csvc.it/app</strong> utilizzando come username e password quelli specificati dal partner.</p>
              </li>
            </ul>
            <h5 className="text-info fw-medium mb-0" style={{marginBottom:"3%"}}>NOTE:</h5>
            <ul>
              <li>In fase di creazione di un nuovo questionario, il sistema provvede a creare un nuovo utente avente come <strong>nome utente</strong> la mail inserita nella prima riga e come <strong>password</strong> la password inserita nella seconda riga. La password proposta di default nella seconda riga può essere cambiata già in fase di creazione del questionario.</li>
              <li>In qualsiasi momento l'utente potrà cambiare la propria password cliccando sul link <strong>"Forgot your password"</strong> presente nel box di login. L'unico vincolo è che l'utente abbia accesso all'email utilizzata come username per poter confermare di essere il titolare della stessa.</li>
              <li>Se creando un questionario viene inserita l'email di un utente già presente nel sistema <span style={{fontStyle:'italic'}}>(il caso tipico è quello del partner che crea un questionario di prova indicando la propria email come username per il questionario di prova)</span> la nuova password non verrà presa in considerazione e l'utente continuerà a utilizzare la password già in suo possesso.</li>
            </ul>
            <p className="text-info fw-medium mb-0" style={{marginBottom:"3%"}}><span style={{color:'red'}}>IMPORTANTE: L'accesso al questionario da parte del referente aziendale potrà essere soggetto a limitazioni temporali in funzione delle condizioni commerciali per l'erogazione del servizio che verranno concordate con le aziende.</span></p><br />
            <hr/>
            <h5 className="text-info fw-medium mb-0" style={{marginBottom:"3%"}}>Da comunicare all'azienda affinchè possa compilare il questionario</h5>
            <br/>
            <p>Dopo aver creato un nuovo questionario riferito ad una azienda, il partner comunicherà al referente dell'azienda le seguenti modalità per poter accedere al sistema:</p>
            <ul>
              <li>
                Andare all'indirizzo web: <strong>https://csvc.it/app/</strong>
              </li>
              <li>
                Username: <strong><em>la mail utilizzata dal partner in fase di creazione del questionario</em></strong>
                </li>
              <li>
                Password: <strong><em>la password assegnata in fase di creazione del questionario</em></strong>
                </li>
              <li>
              Per cambiare la propria password, il referente aziendale potrà cliccare sul link "Forgot your password" presente nel box di login.
              </li>
            </ul>



          </Card.Text>

        </Card.Body>
      </Card>
    </>)
};

export default PartnerPerIniziare;
